import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  selectMyAdsStatistic,
  getMyAdsStatistic,
  renewAd,
  soldAd
} from "../../../routes/Ad/ad.ducks";

import Tabs from "./Tabs";
import TabContent from "./TabContent";
import { useHistory, useLocation } from "react-router-dom";
import { AdStatusHr, QueryParam } from "../../../models";
import { getUrlParams, notification } from "../../../services";
import { AutoRenewal } from "./AutoRenewal";
const MyAds: React.FC = () => {
  const [status, setStatus] = useState(AdStatusHr.aktivan);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const [deleteAdTrigger, setDeleteAdTrigger] = useState(null);
  const [renewAdTriggerId, setRenewAdTriggerId] = useState(null);
  const [renewAdTriggerFromEmail, setRenewAdTriggerFromEmail] = useState(false);

  useEffect(() => {
    const statusForQueryString = status ? Object.entries(AdStatusHr).find(([key, val]) => val === status)[0] : null;
    let tempSearchParams = new URLSearchParams(location.search);

    if (statusForQueryString) {
      tempSearchParams.set(QueryParam.status, statusForQueryString);
    } else {
      tempSearchParams.delete(QueryParam.status);
    }

    history.replace({
      pathname: location.pathname,
      search: tempSearchParams.toString()
    });
  }, [status]);

  const location = useLocation();
  const history = useHistory();
  const statistic = useSelector(selectMyAdsStatistic);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyAdsStatistic());
    const statusFromQueryString = getUrlParams(location.search, QueryParam.status, false);
    if (statusFromQueryString && AdStatusHr[statusFromQueryString] !== undefined) {
      const value = AdStatusHr[statusFromQueryString];
      setStatus(value);
    }
    if (shouldUpdate == true) {
      handleUpdateStatistic(false);
    }
  }, [shouldUpdate]);

  useEffect(() => {

    const queryParams = new URLSearchParams(location.search);
    const action = queryParams.get("action");
    const adId = queryParams.get("adId");
    const utmSource = queryParams.get("utm_source");
    if (!action || !adId) return;

    if (action === "renew") {
      setRenewAdTriggerId(adId)
      setRenewAdTriggerFromEmail(utmSource === "email")
    }

    if (action === "sold") {
      dispatch(soldAd(adId, undefined, (success: boolean) => {
        if (success) {
          return notification.show("Oglas je uspješno označen kao prodan");
        }
      }));
    }

    if (action === "delete") {
      setDeleteAdTrigger(adId)
    }
  }, []);

  function handleUpdateStatistic(state: boolean) {
    setShouldUpdate(state);
  }

  const handleTabChange = value => {
    const matchedValue = (Number.parseInt(value, 10) - 1);
    setStatus(matchedValue);
  };

  return (
    <React.Fragment>
      <AutoRenewal />
      <Tabs
        onTabChange={handleTabChange}
        statistic={statistic}
        status={status}
        updateStatistics={(state: boolean) => handleUpdateStatistic(state)}
        deleteAdTrigger={deleteAdTrigger}
        renewAdTriggerId={renewAdTriggerId}
        renewAdTriggerFromEmail={renewAdTriggerFromEmail}
      >
        <TabContent />
      </Tabs>
    </React.Fragment>
  );
};

export default MyAds;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/index.tsx